import styles from './Auth.module.css';

const DropDownMenu = ({ label, activeItem, items, changeSelection, placeholder }) => {
  return (
    <div>
      <label className={styles['input-label']}>{label}</label>
      <select
        className={styles.customDropDown}
        value={activeItem}
        onChange={(e) => changeSelection(e.target.value)}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {!Array.isArray(items)
          ? Object.entries(items).map(([item]) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))
          : items.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
      </select>
    </div>
  );
};
export default DropDownMenu;
